import { observer } from "mobx-react-lite";
import React from "react";
import { XStack, YStack } from "tamagui";

import {
  type SortableItem,
  type SortableItemWithId,
  SortableList,
} from "../../../core/components/SortableList";
import { Button } from "../../../ui/Button";
import { Input } from "../../../ui/InputNew";

export interface BusinessSortableListProps<T extends SortableItem> {
  itemDescription: string;
  items: T[];
  renderItem: (item: SortableItemWithId<T>) => JSX.Element;
  onSort: (items: T[]) => void;
  onAdd: (title: string) => void;
}

function BusinessSortableListInner<T extends SortableItem>({
  itemDescription,
  items,
  renderItem,
  onSort,
  onAdd,
}: BusinessSortableListProps<T>) {
  const [newTitle, setTitle] = React.useState("");

  return (
    <YStack>
      <SortableList<T>
        items={items}
        onChange={(updatedItems) => onSort(updatedItems.map((u) => u.item))}
        renderItem={renderItem}
      />
      <XStack gap={"$medium"}>
        <Input
          flex={1}
          placeholder={`New ${itemDescription}...`}
          type="border"
          onChangeText={(text) => setTitle(text)}
        />

        <Button
          onPress={() => {
            if (newTitle && onAdd) {
              onAdd(newTitle);
            }
          }}
        >
          Add new {itemDescription}
        </Button>
      </XStack>
    </YStack>
  );
}

export const BusinessSortableList = observer(BusinessSortableListInner) as <
  T extends SortableItem,
>(
  props: BusinessSortableListProps<T>,
) => JSX.Element;
